import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { loadBrands } from 'features/admin/brands/services/brandService';
import { fetchBrandFile } from 'features/brand/fetchBrandFile';
import { logger } from 'features/logger/logger';
import type { BrandFile, DbBrand } from '@hub/common';

export const brandsApi = createApi({
  reducerPath: 'brandsApi',
  baseQuery: fakeBaseQuery<string>(),
  endpoints: builder => ({
    brands: builder.query<DbBrand[], undefined>({
      async queryFn() {
        try {
          return { data: await loadBrands() };
        } catch (error) {
          logger.error(
            'Unable to load brands',
            { details: { error: String(error) } },
            error instanceof Error ? error : undefined
          );
          return { error: String(error) };
        }
      },
    }),
    // A brand file is kept for the session.
    brandFile: builder.query<BrandFile, string>({
      keepUnusedDataFor: Infinity,
      async queryFn(url) {
        try {
          return { data: await fetchBrandFile(url) };
        } catch (error) {
          logger.warn('Unable to load a brand file', {
            details: { url, error: String(error) },
          });
          return { error: String(error) };
        }
      },
    }),
  }),
});

export const { useBrandsQuery, useBrandFileQuery } = brandsApi;
